import { useState } from 'react'
import { message } from 'antd'
import { UpdateProcedureInput } from '../types'

interface UseProcedureUpdateReturn {
  updateProcedure: (input: UpdateProcedureInput) => Promise<void>
  isUpdating: boolean
}

export const useProcedureUpdate = (onSuccess?: () => void): UseProcedureUpdateReturn => {
  const [isUpdating, setIsUpdating] = useState(false)

  const updateProcedure = async (input: UpdateProcedureInput): Promise<void> => {
    setIsUpdating(true)

    // Simulate API call
    return new Promise((resolve) => {
      setTimeout(() => {
        message.success('Procedure updated successfully')
        setIsUpdating(false)

        if (onSuccess) {
          onSuccess()
        }

        resolve()
      }, 500)
    })
  }

  return {
    updateProcedure,
    isUpdating
  }
}
